import { profilesApi } from '@/api';
import { ErrorNotificationIcon, SuccessNotificationIcon } from '@/assets/icons';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useClearChatWhithUser = () => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const mutation = useMutation({
        mutationFn: profilesApi.deleteChatWithUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles'] });
            showToast({
                // type success
                icon: <SuccessNotificationIcon />,
                msg: 'Чат успешно очищен'
            });
        },
        onError: (error) => {
            console.error('Error unvote profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: 'Ошибка. Попробуйте ещё раз'
            });
        },
    });

    return mutation;
};
